/*
 * Inputs validation for type="tel"
 */
document.addEventListener("DOMContentLoaded", function () {
  const telInputs = document.querySelectorAll('input[type="tel"]');

  telInputs.forEach(function (input) {
    input.addEventListener("input", function () {
      this.value = this.value.replace(/[^0-9+\-() ]/g, "");
    });
  });
});

/*
 * Inputs type="password" change state
 */
const eyeOpen = `
    <svg   width="18" height="12" viewBox="0 0 18 12" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9 5.0625C7.2405 5.0625 5.8125 6.4905 5.8125 8.25C5.8125 10.0095 7.2405 11.4375 9 11.4375C10.7595 11.4375 12.1875 10.0095 12.1875 8.25C12.1875 6.4905 10.7595 5.0625 9 5.0625ZM9 6.1875C10.1385 6.1875 11.0625 7.1115 11.0625 8.25C11.0625 9.3885 10.1385 10.3125 9 10.3125C7.8615 10.3125 6.9375 9.3885 6.9375 8.25C6.9375 7.1115 7.8615 6.1875 9 6.1875Z" fill="#A89898"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8973 6.72795C16.8973 6.72795 16.4443 6.27495 15.7618 5.5917C12.0268 1.85745 5.97281 1.85745 2.23781 5.5917C1.55531 6.27495 1.10231 6.72795 1.10231 6.72795C0.882562 6.94695 0.882562 7.30395 1.10231 7.52295C1.32131 7.7427 1.67831 7.7427 1.89731 7.52295C1.89731 7.52295 2.35031 7.06995 3.03356 6.38745C6.32831 3.09195 11.6713 3.09195 14.9661 6.38745C15.6493 7.06995 16.1023 7.52295 16.1023 7.52295C16.3213 7.7427 16.6783 7.7427 16.8973 7.52295C17.1171 7.30395 17.1171 6.94695 16.8973 6.72795Z" fill="#A89898"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1374 2.14979L13.0124 4.09829C12.8579 4.36679 12.9501 4.71104 13.2186 4.86629C13.4871 5.02154 13.8321 4.92929 13.9874 4.66079L15.1124 2.71229C15.2669 2.44304 15.1746 2.09879 14.9061 1.94354C14.6376 1.78829 14.2926 1.88054 14.1374 2.14979Z" fill="#A89898"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.4375 1.125V3.375C8.4375 3.6855 8.6895 3.9375 9 3.9375C9.3105 3.9375 9.5625 3.6855 9.5625 3.375V1.125C9.5625 0.8145 9.3105 0.5625 9 0.5625C8.6895 0.5625 8.4375 0.8145 8.4375 1.125Z" fill="#A89898"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.88738 2.71229L4.01238 4.66079C4.16763 4.92929 4.51263 5.02154 4.78113 4.86629C5.04963 4.71104 5.14188 4.36679 4.98738 4.09829L3.86238 2.14979C3.70713 1.88054 3.36213 1.78829 3.09363 1.94354C2.82513 2.09879 2.73288 2.44304 2.88738 2.71229Z" fill="#A89898"/>
    </svg>
  `;

const eyeClosed = `
    <svg   width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.94806 4.99961C1.18147 4.80945 1.52827 4.8404 1.72265 5.06873C3.00776 6.57828 5.3388 8.46195 9 8.46195C12.6611 8.46195 14.9921 6.5783 16.2772 5.06875C16.4716 4.84042 16.8184 4.80947 17.0518 4.99963C17.2852 5.18979 17.3169 5.52905 17.1225 5.75738C16.7262 6.22292 16.2352 6.725 15.6433 7.20643C15.6751 7.24127 15.7028 7.28078 15.7252 7.32458L17.1918 10.1941C17.3276 10.4599 17.2175 10.7831 16.9459 10.916C16.6741 11.0489 16.3438 10.9411 16.2079 10.6754L14.7642 7.85055C13.8489 8.45168 12.7487 8.96925 11.4488 9.26738L12.1059 12.4814C12.1654 12.7727 11.9723 13.0562 11.6744 13.1144C11.3766 13.1727 11.0869 12.9838 11.0273 12.6924L10.3657 9.45645C9.93015 9.50948 9.47505 9.53798 9 9.53798C8.52488 9.53798 8.06977 9.50948 7.63417 9.45645L6.97263 12.6924C6.91306 12.9838 6.6233 13.1727 6.32545 13.1144C6.02759 13.0562 5.83443 12.7727 5.894 12.4814L6.55109 9.2673C5.47864 9.02138 4.54215 8.62605 3.73326 8.15768L1.74002 10.7576C1.55777 10.9952 1.21304 11.0435 0.970028 10.8652C0.727028 10.6868 0.677779 10.3496 0.860033 10.1119L2.81626 7.5603C2.01435 6.97655 1.37213 6.33849 0.877403 5.75737C0.683015 5.52903 0.71465 5.18978 0.94806 4.99961Z" fill="#A89898"/>
    </svg>
  `;

document.querySelectorAll('input[type="password"]').forEach((input) => {
  if (input.closest(".password-wrapper")) return;

  const wrapper = document.createElement("div");
  wrapper.classList.add("password-wrapper");

  const toggleBtn = document.createElement("button");
  toggleBtn.type = "button";
  toggleBtn.className = "toggle-password";
  toggleBtn.innerHTML = eyeClosed;

  input.parentNode.insertBefore(wrapper, input);
  wrapper.appendChild(input);
  wrapper.appendChild(toggleBtn);

  toggleBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    const isVisible = input.type === "text";
    input.type = isVisible ? "password" : "text";
    toggleBtn.innerHTML = isVisible ? eyeClosed : eyeOpen;
  });
});

/**
 * Tabs for header
 */
if (document.querySelector(".drawer-js")) {
  const faqsItems = document.querySelectorAll(".drawer-js");

  faqsItems.forEach((elem) => {
    let btn = elem.querySelector(".drawer__btn-js");
    let content = elem.querySelector(".drawer__content-js");

    btn.addEventListener("click", () => {
      content.classList.toggle("active");
    });
  });
}

/**
 * Swiper for '.collection-list' block
 */
if (document.querySelector(".collection-list")) {
  var swiper = new Swiper(".collection-listSwiper", {
    slidesPerView: 4.1,
    spaceBetween: 32,
    loop: 1,
    speed: 4000,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    breakpoints: {
      175: {
        slidesPerView: 1.2,
        centeredSlides: false,
      },
      500: {
        slidesPerView: 2.3,
        spaceBetween: 24,
      },
      788: {
        slidesPerView: 3.1,
        spaceBetween: 24,
      },
      1025: {
        slidesPerView: 3.6,
        spaceBetween: 32,
      },
      1500: {
        slidesPerView: 3.9,
        spaceBetween: 32,
      },
    },
  });
}

/**
 * GSAP announcement-bar line
 */
let tweenMain = gsap
  .to(".announcement-bar__wrap", {
    xPercent: -100,
    repeat: -1,
    duration: 210,
    ease: "linear",
  })
  .totalProgress(0.5);
gsap.set(".announcement-bar__wrap", { xPercent: 0 });

/**
 * Header bg changer
 */

const menuDrawer = document.querySelector("#Details-menu-drawer-container");
const header = document.querySelector(".header-wrapper");

const closeBtn = document.querySelector(".menu-drawer-close-js");

closeBtn.addEventListener("click", () => {
  menuDrawer.classList.remove("menu-opening");

  setTimeout(() => {
    menuDrawer.removeAttribute("open");
  }, 400);
});

// menuDrawer.addEventListener("click", () => {
// setTimeout(() => {
//   if (menuDrawer.classList.contains("menu-opening")) {
//     header.classList.add("active");
//   } else {
//     header.classList.remove("active");
//   }
// }, 100); // Задержка 0.5 секунды
// });


/**
 * Filter + Sord button add ui 
 */
const facetsWrapper = document.querySelectorAll(".facets__wrapper-js")

const initUiButtons = () => {
  facetsWrapper.forEach(elem=>{
    let inputs = elem.querySelectorAll("label")
    let buttons = elem.querySelectorAll("button")
   
    buttons.forEach(button=>{
      button.classList.add("pink")
    })

    inputs.forEach(input=>{
      input.addEventListener("click",()=>{
  
        console.log("click")
  
        buttons.forEach(button=>{
          button.classList.remove("pink")
        })
      })
    })
  })
}



if(window.innerWidth < 1024){
  let mobileFacetsWrapper = document.querySelectorAll(".mobile-facets__wrapper");

  mobileFacetsWrapper.forEach(elem => {
    elem.addEventListener("click",()=>{
      
      setTimeout(() => {
        initUiButtons ()
      }, 1000);
    }) 
  });
}else{
  initUiButtons ()
}



// ----------------------------------------------------------------------
// 🌿  GLOBAL REVEAL-ON-SCROLL SYSTEM (FOUC-safe + Hero-safe)
// ----------------------------------------------------------------------

function initRevealOnScroll() {
  // Exit if GSAP or ScrollTrigger isn't available
  if (typeof gsap === 'undefined' || !gsap.registerPlugin || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not loaded');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // Select all reveal elements
  const revealElements = document.querySelectorAll(
    '.reveal-on-scroll, .reveal-fade, .reveal-slide-up, .reveal-slide-left'
  );

  if (revealElements.length === 0) return;

  revealElements.forEach(element => {
    // 🚫 Skip elements inside the expanding-hero section
    if (element.closest('[data-expanding-hero]')) return;

    // Initial states
    if (element.classList.contains('reveal-slide-up')) {
      gsap.set(element, { y: 30, opacity: 0 });
    } else if (element.classList.contains('reveal-slide-left')) {
      gsap.set(element, { x: -30, opacity: 0 });
    } else {
      gsap.set(element, { opacity: 0 });
    }

    // Optional delay utility
    let delay = 0;
    for (let i = 0; i <= 1000; i += 100) {
      if (element.classList.contains(`delay-${i}`)) {
        delay = i / 1000;
        break;
      }
    }

    // Reveal animation
    gsap.to(element, {
      y: 0,
      x: 0,
      opacity: 1,
      duration: 1.2,
      delay: delay,
      ease: "power2.out",
      scrollTrigger: {
        trigger: element,
        start: "top bottom-=10%",
        toggleActions: "play none none none",
        once: true,
        // 🔹 ADD INVALIDATION TO RECALCULATE
        invalidateOnRefresh: true
      }
    });
  });

  // Stagger groups...
  const staggerGroups = document.querySelectorAll('.stagger-group');

  staggerGroups.forEach(group => {
    if (group.closest('[data-expanding-hero]')) return;

    const items = group.querySelectorAll(
      '.reveal-on-scroll, .reveal-fade, .reveal-slide-up, .reveal-slide-left'
    );

    if (items.length === 0) return;

    items.forEach(item => {
      if (item.classList.contains('reveal-slide-up')) {
        gsap.set(item, { y: 30, opacity: 0 });
      } else if (item.classList.contains('reveal-slide-left')) {
        gsap.set(item, { x: -30, opacity: 0 });
      } else {
        gsap.set(item, { opacity: 0 });
      }
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: group,
        start: "top bottom-=10%",
        toggleActions: "play none none none",
        once: true,
        // 🔹 ADD INVALIDATION
        invalidateOnRefresh: true
      }
    });

    tl.to(items, {
      y: 0,
      x: 0,
      opacity: 1,
      duration: 1.2,
      stagger: 0.1,
      ease: "power2.out"
    });
  });

  // 🔹 ENSURE REFRESH HAPPENS AFTER ALL TRIGGERS ARE SET
  ScrollTrigger.refresh();
}

// 🔹 UPDATED: Add delay to ensure expanding hero initializes first
document.addEventListener('DOMContentLoaded', () => {
  // Small delay to let pinned sections establish first
  setTimeout(initRevealOnScroll, 100);
});

// Re-initialize when Shopify dynamically loads sections
document.addEventListener('shopify:section:load', () => {
  setTimeout(initRevealOnScroll, 150);
});

/*end of reveal animation*/ 


/*------------------
* PAPER REVEAL ANIMATION
*-----------------*/


document.addEventListener('click', function (e) {
  const btn = e.target.closest('.paper-trigger .button');
  if (!btn) return;

  const root = btn.closest('.paper') || document;
  const panel = root.querySelector('.paper-reveal');
  if (!panel) return;

  const opening = !panel.classList.contains('is-open');
  panel.classList.toggle('is-open', opening);

  btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
  if (!panel.id) panel.id = 'paper-' + Math.random().toString(36).slice(2);
  btn.setAttribute('aria-controls', panel.id);

  // 🔧 key tweak: get the true target height when opening
  if (opening) {
    panel.style.maxHeight = 'none';                 // allow natural height
    var targetHeight = panel.scrollHeight;          // measure full height
    panel.style.maxHeight = '0px';                  // reset to start state
    panel.offsetHeight;                             // force reflow
    requestAnimationFrame(() => {
      panel.style.maxHeight = targetHeight + 'px';  // animate to full height
    });
  } else {
    // closing: animate from current height to 0
    panel.style.maxHeight = panel.scrollHeight + 'px';
    panel.offsetHeight;
    requestAnimationFrame(() => {
      panel.style.maxHeight = '0px';
    });
  }

  // cleanup after the height transition ends
  const onEnd = (ev) => {
    if (ev.target !== panel || ev.propertyName !== 'max-height') return;
    panel.removeEventListener('transitionend', onEnd);
    if (panel.classList.contains('is-open')) {
      panel.style.maxHeight = 'none'; // let it be natural after opening
    }
  };
  panel.addEventListener('transitionend', onEnd, { once: true });
});



/* end of paper reveal animation*/



/*text reveal animation*/
document.addEventListener('DOMContentLoaded', function() {
  const textElement = document.querySelector(".quote-animate h3 em");
  
  if (textElement) {
    gsap.registerPlugin(ScrollTrigger, SplitText);
    
    // Split text into words
    const split = new SplitText(textElement, { 
      type: "words"
    });
    
    // Set initial opacity to 0.5
    gsap.set(split.words, { opacity: 0.5 });
    
    // Animate each word to full opacity
    gsap.to(split.words, {
      opacity: 1,
      stagger: 0.2, // Adjust timing between words (lower = faster)
      scrollTrigger: {
        trigger: textElement,
        start: "top 650%", // Start when element is 80% down viewport
        end: "bottom 35%", // End animation here
        scrub: 1, // Smooth scrub (1 second catch-up)
        // markers: true // Uncomment to see trigger points for debugging
      }
    });
  }
});

/*end of text reveal animation*/





// ----------------------------------------------------------
// GLOBAL — Simple Scroll-from-Sides Animation
// ----------------------------------------------------------
// ----------------------------------------------------------
// GLOBAL — Simple Scroll-from-Sides Animation
// ----------------------------------------------------------

function initScrollSideAnimations(root = document) {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    console.warn('⚠️ GSAP or ScrollTrigger not loaded for scroll-side animations');
    return;
  }

  // 🔧 CRITICAL: Register ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);

  // LEFT → RIGHT
  root.querySelectorAll('.scrollFromLeft').forEach((el) => {
    if (el.dataset.scrollInit) return; 
    el.dataset.scrollInit = "1";

    // Clear any existing transforms
    el.style.transform = '';

    gsap.fromTo(
      el,
      { xPercent: -40 },
      {
        xPercent: 80,
        ease: "none",
        scrollTrigger: {
          trigger: el.closest('.scroll-titles') || el, // Use section as trigger
          start: "top bottom",
          end: "bottom top",
          scrub: 1.3,
          // markers: true, // Uncomment for debugging
        }
      }
    );
  });

  // RIGHT → LEFT
  root.querySelectorAll('.scrollFromRight').forEach((el) => {
    if (el.dataset.scrollInit) return;
    el.dataset.scrollInit = "1";

    // Clear any existing transforms
    el.style.transform = '';

    gsap.fromTo(
      el,
      { xPercent: 40 },
      {
        xPercent: -80,
        ease: "none",
        scrollTrigger: {
          trigger: el.closest('.scroll-titles') || el, // Use section as trigger
          start: "top bottom",
          end: "bottom top",
          scrub: 1.3,
          // markers: true, // Uncomment for debugging
        }
      }
    );
  });

  // Refresh ScrollTrigger after setup
  requestAnimationFrame(() => {
    ScrollTrigger.refresh();
  });
}

function runScrollSideInit() {
  // Add delay to ensure GSAP is fully loaded
  setTimeout(() => {
    initScrollSideAnimations(document);
  }, 100);
}

// DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runScrollSideInit);
} else {
  runScrollSideInit();
}

// Shopify section reload
document.addEventListener("shopify:section:load", (event) => {
  setTimeout(() => {
    initScrollSideAnimations(event.target);
  }, 150);
});

/* end of scroll left and right animation */

